import MieszkaniecDaneWodaRozliczenieDokument from "./MieszkaniecDaneWodaRozliczenieDokument";
import MieszkaniecDaneWodaRozliczenieWydrukNaglowek from "./MieszkaniecDaneWodaRozliczenieWydrukNaglowek";
import MieszkaniecDaneWodaRozliczenieWydrukAdresat from "./MieszkaniecDaneWodaRozliczenieWydrukAdresat";
import MieszkaniecDaneWodaRozliczenieWydrukStan from "./MieszkaniecDaneWodaRozliczenieWydrukStan";
import MieszkaniecDaneWodaRozliczenieWydrukZaliczki from "./MieszkaniecDaneWodaRozliczenieWydrukZaliczki";
import MieszkaniecDaneWodaRozliczenieWydrukKoszty from "./MieszkaniecDaneWodaRozliczenieWydrukKoszty";
import MieszkaniecDaneWodaRozliczenieWydrukPodsumowanie from "./MieszkaniecDaneWodaRozliczenieWydrukPodsumowanie";
import MieszkaniecDaneWodaRozliczenieWydrukLegenda from "./MieszkaniecDaneWodaRozliczenieWydrukLegenda";

const MieszkaniecDaneWodaRozliczenieWydrukA4 = props => {
    
    const { componentRef, rozliczenieWodyAkt, procent, odczyty, mieszkaniec, adres } = props;    

    return (
        <div    
            style={{
                width: '21cm',
                height: '29.7cm',
                backgroundColor: 'white',
                // boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
                padding: '15mm 15mm',
                boxSizing: 'border-box',
                maxWidth: '100%',
                maxHeight: '100%',
                // fontSize: '14px',
                position: 'relative'
            }}
            ref={componentRef ? componentRef : null}
        >
            <MieszkaniecDaneWodaRozliczenieWydrukNaglowek />
            <MieszkaniecDaneWodaRozliczenieWydrukAdresat 
                mieszkaniec={mieszkaniec}
                adres={adres}
            />
            
            <section style={{marginBottom: "30px"}}>
                <p style={{textAlign: "center", fontWeight: "600", fontSize: "1rem"}}>
                    {rozliczenieWodyAkt?.opis}   
                </p>
            </section>

            <MieszkaniecDaneWodaRozliczenieWydrukStan
                procent={procent}
                odczyty={odczyty}       
            />

            <MieszkaniecDaneWodaRozliczenieWydrukZaliczki
                rozliczenieWodyAkt={rozliczenieWodyAkt}
                procent={procent}
            />

            <section style={{display: "flex", justifyContent:"center", marginBottom: "30px"}}>
                <p style={{border: "1px solid black", padding: "5px 10px", textAlign: "center", width: "fit-content", fontSize: "0.75rem"}}>
                    {`Powierzchnia lokalu `}
                    <span style={{fontWeight: "600", fontSize: "0.75rem"}}>{`${procent?.metraz} m²`}</span>
                </p>
            </section>

            <MieszkaniecDaneWodaRozliczenieWydrukKoszty
                rozliczenieWodyAkt={rozliczenieWodyAkt}
                procent={procent}
            />

            <MieszkaniecDaneWodaRozliczenieWydrukPodsumowanie
                procent={procent}
            />

            <MieszkaniecDaneWodaRozliczenieWydrukLegenda
                rozliczenieWodyAkt={rozliczenieWodyAkt}
                procent={procent}
            />
            <MieszkaniecDaneWodaRozliczenieDokument />
        </div>
    )
}

export default MieszkaniecDaneWodaRozliczenieWydrukA4;